import { render, staticRenderFns } from "./ProjectClosePopover.vue?vue&type=template&id=b2bc4d26&scoped=true&"
import script from "./ProjectClosePopover.vue?vue&type=script&lang=ts&"
export * from "./ProjectClosePopover.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectClosePopover.vue?vue&type=style&index=0&id=b2bc4d26&prod&lang=scss&scoped=true&"
import style1 from "./ProjectClosePopover.vue?vue&type=style&index=1&id=b2bc4d26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bc4d26",
  null
  
)

export default component.exports